// extracted by mini-css-extract-plugin
export default {"wrapper":"RegisterPage_wrapper__FQVtO","container":"RegisterPage_container__+BCzu","Register":"RegisterPage_Register__39zt+","Title":"RegisterPage_Title__ZyKlm"};